import { render, staticRenderFns } from "./comp_uploadTemplate.vue?vue&type=template&id=0ef2d34c&scoped=true&"
import script from "./comp_uploadTemplate.vue?vue&type=script&lang=js&"
export * from "./comp_uploadTemplate.vue?vue&type=script&lang=js&"
import style0 from "./comp_uploadTemplate.vue?vue&type=style&index=0&id=0ef2d34c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef2d34c",
  null
  
)

export default component.exports